import { Component, OnInit } from '@angular/core';
import { TabName } from '../../../models/_enum-collections';
import { PreviewDocumentTypes } from '../../../models/update-customer-ack-document.model';
import { SpecialInvestmentTableComponent } from '../../shared/special-investment-table/special-investment-table.component';

@Component({
  selector: 'app-rfp-description',
  templateUrl: './rfp-description.component.html',
  styleUrls: ['./rfp-description.component.scss'],
  standalone: true,
  imports: [SpecialInvestmentTableComponent]
})
export class RfpDescriptionComponent implements OnInit {
  tabName!: number;
  prevDocumentType!: string;

  ngOnInit() {
    this.tabName = TabName.RfpDescription;
    this.prevDocumentType = PreviewDocumentTypes.rfpDescription;
  }
}
